// Function used for modal follow me contact
const renderScrollToLink = () => {
	const link = document.getElementById("modal-follow-me-contact-link");
	const targetElement = document.getElementsByClassName(
		"gform_wrapper"
	)[0];

	if (link && targetElement) {
		link.addEventListener("click", function (e) {
			e.preventDefault();

			targetElement.scrollIntoView({
				behavior: "smooth",
			});
		});
	}
};

export default renderScrollToLink;
